import { Business } from './Businesses';
import { Common } from './Common';
import { User } from './Users';

export class Employee extends Common {
    uuid: string;
    user_id: string;
    user: User;
    business_id: string;
    business: Business;
    date_joining: Date;
    designation: string;
    date_meta: Date;
    permissions: string[] = [];
    type: string;
    access: string[];

    family_id: string;
    family_head: string;

    assigned_area: string[];

    manager_id: string;
    manager: Employee;

    color: string;
    creator_can_edit: boolean = true;
    fcm_token: any;
}